const access = [
  {
    path: '/api_gift/products',
    name: 'api-products',
    component: () => import('@/views/apiGift/products/Products.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_menu_api_gift',
      resource: 'all',
    },
  },
  {
    path: '/api_gift/categories',
    name: 'api-categories',
    component: () => import('@/views/apiGift/Categories.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_menu_api_gift',
      resource: 'all',
    },
  },
  {
    path: '/api_gift/logs',
    name: 'api-logs',
    component: () => import('@/views/apiGift/Logs.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_apigift_buy_log',
      resource: 'all',
    },
  },
  {
    path: '/api_gift/wallet',
    name: 'api-wallet',
    component: () => import('@/views/apiGift/Wallet.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_menu_api_gift',
      resource: 'all',
    },
  },
  {
    path: '/api_gift/setting',
    name: 'api-setting',
    component: () => import('@/views/apiGift/Setting.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_menu_api_gift',
      resource: 'all',
    },
  },
]

export default access
